import { useState } from "react";
import { Avatar, Button, Layout, Modal, Popover, Space } from "antd";
import {
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const { Header } = Layout;

const AppHeader = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showLogoutModal = () => {
    setIsModalVisible(true);
  };

  const handleLogout = () => {
    setIsModalVisible(false);
    localStorage.removeItem("token");
    toast.success("Logged out Successfully");
    navigate("/auth/login");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const logoutPopoverContent = (
    <Button
      type="text"
      icon={<LogoutOutlined />}
      onClick={showLogoutModal}
      style={{
        width: "100%",
        textAlign: "left",
        color: "#333",
      }}
    >
      Log Out
    </Button>
  );

  return (
    <Header
      style={{
        background: "linear-gradient(135deg, #0471a3 0%, #0369a1 100%)",
        padding: "0 32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 4px 20px rgba(4, 113, 163, 0.15)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <Space align="center">
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={{
            fontSize: "18px",
            width: 48,
            height: 48,
            color: "white",
            borderRadius: "12px",
            transition: "all 0.3s ease",
            background: "rgba(255, 255, 255, 0.1)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            outline: "none",
            boxShadow: "none",
          }}
        />
      </Space>

      <Popover
        content={logoutPopoverContent}
        trigger="click"
        placement="bottomRight"
        overlayStyle={{ padding: 0 }}
      >
        <div style={{ cursor: "pointer" }}>
          <Avatar
            size={40}
            icon={<UserOutlined />}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              border: "2px solid rgba(255, 255, 255, 0.3)",
            }}
          />
        </div>
      </Popover>

      <Modal
        title="Confirm Logout"
        open={isModalVisible}
        onOk={handleLogout}
        onCancel={handleCancel}
        okText="Log Out"
        cancelText="Cancel"
        centered
      >
        <p>Are you sure you want to log out?</p>
      </Modal>
    </Header>
  );
};

export default AppHeader;
